import axios from 'axios'
import { appStore, authStore } from '~/stores'
import { convertKeysToSnakeCase } from '~/common/helpers/mapping.helper'

export const createAxios = (headers) => {
	return axios.create({
		baseURL: process.env.REACT_APP_TRACKING_API_URL,
		headers: {
			'x-api-key': process.env.REACT_APP_TRACKING_API_KEY,
			'tenant-id': process.env.REACT_APP_COMPANY_ID,
			...headers,
		},
		method: 'PUT',
		timeout: 30000,
	})
}

const records = async (dataValue) => {
	try {
		const userProperties = {
			id: authStore.id,
			company_id: appStore.id,
			work_authorized: authStore.activated,
		}
		dataValue.data.userProperties = convertKeysToSnakeCase(userProperties)
		dataValue.data.anonymous_id = null
		dataValue.is_mobile = false
		dataValue.is_anonymous = false
		dataValue.user_id = authStore.id
		dataValue.company_id = process.env.REACT_APP_COMPANY_ID
		dataValue.timestamp = +Math.floor(Date.now() / 1000)

		// TODO: Uncomment-out when the API is ready
		const trackingData = {
			is_anonymous: authStore.isAnonymous,
			Records: [convertKeysToSnakeCase(dataValue)],
		}
		if (authStore.id) {
			return await createAxios().put('/records', trackingData)
		} else {
			return await createAxios().put('/anonymous', trackingData)
		}
	} catch (error) {
		console.log('error', error)
		return null
	}
}

export const httpRequestTracking = {
	record: records,
}
